import {
    DASHBOARD_PAGE_NEXT,
    DASHBOARD_PAGE_PREV,
    DASHBOARD_RESET,
    DASHBOARD_PAGE_SET_DATA,
    DASHBOARD_ELEVATE_SUCCESS
} from './constants';

import {getAllMyAds, getAllMyStores, getAllMyFavourites, latestPrices} from '../services/auth'
import {getAllMyAlarms} from '../services/alarms'
import {elevateVehicle} from '../services/vehicle'
import {elevateJob} from '../services/job'
import {elevateAgency} from '../services/agency'
import {elevateGallery} from '../services/gallery'

export const dashboardReset = () => ({
    type: DASHBOARD_RESET,
    payload: {}
});

export const nextPage = () => ({
    type: DASHBOARD_PAGE_NEXT,
    payload: {}
});

export const prevPage = () => ({
    type: DASHBOARD_PAGE_PREV,
    payload: {}
});

const setData = (payload) => ({
    type: DASHBOARD_PAGE_SET_DATA,
    payload
});

export const startGetAllMyAds = () => {
    return (dispatch, getState) => {
        const filters = {page: getState().dashboard.page, page_size: getState().dashboard.page_size};
        return getAllMyAds({
            parameter: filters,
            header: {
                Authorization: `Token ${getState().auth.token}`
            },
        })
        .then((response) => {
            dispatch(setData(response.data))
            return {
                success: {
                    status: response.status,
                    body: response.data
                }
            }
        })
        .catch((error) => {
            return {
                error: {
                    status: error.response.status,
                    body: error.response.data
                }
            }
        })
    }
};

export const startGetAllMyStores = () => {
    return (dispatch, getState) => {
        const filters = {page: getState().dashboard.page, page_size: getState().dashboard.page_size};
        return getAllMyStores({
            parameter: filters,
            header: {
                Authorization: `Token ${getState().auth.token}`
            },
        })
        .then((response) => {
            dispatch(setData(response.data))
            return {
                success: {
                    status: response.status,
                    body: response.data
                }
            }
        })
        .catch((error) => {
            return {
                error: {
                    status: error.response.status,
                    body: error.response.data
                }
            }
        })
    }
};

export const startGetAllMyAlarms = () => {
    return (dispatch, getState) => {
        const filters = {page: getState().dashboard.page, page_size: getState().dashboard.page_size};
        return getAllMyAlarms({
            parameter: filters,
            header: {
                Authorization: `Token ${getState().auth.token}`
            },
        })
        .then((response) => {
            dispatch(setData(response.data))
            return {
                success: {
                    status: response.status,
                    body: response.data
                }
            }
        })
        .catch((error) => {
            return {
                error: {
                    status: error.response.status,
                    body: error.response.data
                }
            }
        })
    }
};

export const startGetAllMyFavourites = () => {
    return (dispatch, getState) => {
        const filters = {page: getState().dashboard.page, page_size: getState().dashboard.page_size};
        return getAllMyFavourites({
            parameter: filters,
            header: {
                Authorization: `Token ${getState().auth.token}`
            },
        })
        .then((response) => {
            dispatch(setData(response.data))
            return {
                success: {
                    status: response.status,
                    body: response.data
                }
            }
        })
        .catch((error) => {
            return {
                error: {
                    status: error.response.status,
                    body: error.response.data
                }
            }
        })
    }
};

export const startGetLatestPrices = () => {
    return (dispatch, getState) => {
        const filters = {page: getState().dashboard.page, page_size: getState().dashboard.page_size};
        return latestPrices({
            parameter: filters,
            header: {
                Authorization: `Token ${getState().auth.token}`
            },
        })
        .then((response) => {
            let transformedData = []
            response.data.results.forEach((el) => el.vehicles.forEach((vehic) => transformedData.push(vehic)))
            dispatch(setData({count: transformedData.length, results: transformedData}))
            return {
                success: {
                    status: response.status,
                    body: response.data
                }
            }
        })
        .catch((error) => {
            return {
                error: {
                    status: error.response.status,
                    body: error.response.data
                }
            }
        })
    }
};

export const startElevateVehicle = (id=0) => {
    return (dispatch, getState) => {
        return elevateVehicle({
            header: {
                Authorization: `Token ${getState().auth.token}`
            },
        }, id)
        .then((response) => {
            dispatch(elevateSuccess())
            return {
                success: {
                    status: response.status,
                    body: response.data
                }
            }
        })
        .catch((error) => {
            return {
                error: {
                    status: error.response.status,
                    body: error.response.data
                }
            }
        })
    }
};

export const startElevateJob = (id=0) => {
    return (dispatch, getState) => {
        return elevateJob({
            header: {
                Authorization: `Token ${getState().auth.token}`
            },
        }, id)
        .then((response) => {
            dispatch(elevateSuccess())
            return {
                success: {
                    status: response.status,
                    body: response.data
                }
            }
        })
        .catch((error) => {
            return {
                error: {
                    status: error.response.status,
                    body: error.response.data
                }
            }
        })
    }
};

export const startElevateAgency = (id=0) => {
    return (dispatch, getState) => {
        return elevateAgency({
            header: {
                Authorization: `Token ${getState().auth.token}`
            },
        }, id)
        .then((response) => {
            dispatch(elevateSuccess())
            return {
                success: {
                    status: response.status,
                    body: response.data
                }
            }
        })
        .catch((error) => {
            return {
                error: {
                    status: error.response.status,
                    body: error.response.data
                }
            }
        })
    }
};

export const startElevateGallery = (id=0) => {
    return (dispatch, getState) => {
        return elevateGallery({
            header: {
                Authorization: `Token ${getState().auth.token}`
            },
        }, id)
        .then((response) => {
            dispatch(elevateSuccess())
            return {
                success: {
                    status: response.status,
                    body: response.data
                }
            }
        })
        .catch((error) => {
            return {
                error: {
                    status: error.response.status,
                    body: error.response.data
                }
            }
        })
    }
};

const elevateSuccess = () => ({
    type: DASHBOARD_ELEVATE_SUCCESS,
    payload: {}
});